import i18nConfig from "@/config/i18nConfig"
import { Ticket, TicketReportItem, TimeSlot } from "@/generated/openapi"
import { PersonalData } from "@/models/PersonalData"
import { DateTime } from "luxon"
import { asDateTime } from "./dateTimeUtils"

function leftPad(n: number|undefined, size: number) {
  let str = ''
  if (n) {
    str += n
  }
  while (str.length < size) {
    str = '0' + str
  }
  return str
}

function formatMinutes(n: number) {
  return Math.round(n)
}

function formatTicketTime(ticket: Ticket|TimeSlot|TicketReportItem) {
  if (!ticket.date || !ticket.startTime || !ticket.endTime) {
    return ''
  }
  const day = asDateTime(ticket.date).toFormat('dd.MM.yyyy')
  const from = ticket.startTime.substring(0, 5)
  const until = ticket.endTime.substring(0, 5)
  return `${day} ${from} – ${until}`
}

function formatTicketTimeDay(ticket: Ticket|TicketReportItem) {
  if (!ticket.date) {
    return ''
  }
  return formatDateString(ticket.date);
}

function formatDateString(str: string) {
  return asDateTime(str).toFormat('d. MMMM yyyy')
}

function formatTicketTimeOnly(ticket: Ticket|TicketReportItem) {
  if (!ticket.startTime || !ticket.endTime) {
    return ''
  }
  const from = ticket.startTime.substring(0, 5)
  const until = ticket.endTime.substring(0, 5)
  return `${from} – ${until}`
}

function formatDateTime(dateTime?: DateTime) {
  if (!dateTime) {
    return ''
  }
  return dateTime.toFormat('d. MMMM yyyy hh:MM')
}

function formatFullName(personalData: PersonalData) {
  if(personalData.salutation === "NONE"){
    if(personalData.title !== ""){
      return `${personalData.title} ${personalData.givenName} ${personalData.surName}`
    }else{
      return `${personalData.givenName} ${personalData.surName}`
    }
  }else{
    if(personalData.title !== ""){
      return `${i18nConfig.global.t('common.owner.salutations.' + personalData.salutation)} ${personalData.title} ${personalData.givenName} ${personalData.surName}`
    }else{
      return `${i18nConfig.global.t('common.owner.salutations.' + personalData.salutation)} ${personalData.givenName} ${personalData.surName}`
    }
  }
}

export {
  leftPad,
  formatMinutes,
  formatTicketTime,
  formatTicketTimeDay,
  formatTicketTimeOnly,
  formatFullName,
  formatDateTime,
  formatDateString
}
